import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Settings2, Instagram, Youtube, Linkedin, Mail } from "lucide-react";
import Logo from "./Logo";
import { getConfig } from "../mock/mock";

const COLS = [
  {
    title: "Herramientas",
    links: ["Difuminar caras", "Difuminar matrículas", "Fondo desenfocado", "Difuminar objetos", "Emoji sobre caras"],
  },
  {
    title: "Producto",
    links: ["Editor de vídeo", "Tarifas", "Casos de uso", "Novedades"],
  },
  {
    title: "Ayuda",
    links: ["Preguntas frecuentes", "Guías rápidas", "Contacto", "Estado del servicio"],
  },
  {
    title: "Legal",
    links: ["Privacidad", "Condiciones de uso", "Cookies", "RGPD"],
  },
];

const Footer = () => {
  const [config, setConfigState] = useState(getConfig());

  useEffect(() => {
    const upd = () => setConfigState(getConfig());
    window.addEventListener("naturblur-config", upd);
    return () => window.removeEventListener("naturblur-config", upd);
  }, []);

  if (!config.footer.visible) return null;

  return (
    <footer className="bg-[#1C1712] text-white">
      <div className="max-w-[1240px] mx-auto px-6 pt-16 pb-10">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-10">
          <div className="col-span-2">
            <Logo dark />
            <p className="text-[13.5px] leading-relaxed text-white/55 max-w-xs mt-5">
              Difumina caras, matrículas, fondos y objetos en tus vídeos con IA.
              Privacidad profesional sin conocimientos de edición.
            </p>
            <div className="flex gap-2.5 mt-6">
              {[Instagram, Youtube, Linkedin, Mail].map((Icon, i) => (
                <button
                  key={i}
                  className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#F26F21] transition-colors"
                  aria-label="red social"
                >
                  <Icon size={15} />
                </button>
              ))}
            </div>
          </div>
          {COLS.map((col) => (
            <div key={col.title}>
              <h4 className="text-[12px] font-extrabold uppercase tracking-[0.14em] text-[#FFB81C] mb-4">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map((l) => (
                  <li key={l}>
                    <Link
                      to={l === "Tarifas" ? "/tarifas" : "/editor"}
                      className="text-[13.5px] text-white/70 hover:text-[#FFB81C] transition-colors"
                    >
                      {l}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[12.5px] text-white/40">© 2025 Natur Blur · Una herramienta del ecosistema Natur</p>
          <Link to="/admin" className="inline-flex items-center gap-1.5 text-[12.5px] text-white/40 hover:text-[#FFB81C] transition-colors">
            <Settings2 size={13} /> Backoffice
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
